module.exports = __webpack_public_path__ + "static/media/spoon.72422a1a.svg";